module.exports = __webpack_public_path__ + "media/images/twitter-f7a759e843779ab1f9f0eb3009800ef2.svg";